@if (isActive) {
  <topo-modal
    [isActive]="isActive"
    [backgroundCanClose]="true"
    [isCard]="true"
    (close)="close()">
    <div class="modal-header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">
          {{
          (configuredChannel?.uId === emptyGuid
          ? 'MANAGEMENT.COMMUNICATION-CENTER.CREATE-CHANNEL'
          : 'MANAGEMENT.COMMUNICATION-CENTER.UPDATE-CHANNEL'
          ) | translate
          }}
        </h5>
        <div
          class="dialog-close"
          (click)="close()">
          <i class="icon icon-close-X"></i>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <form>
        <div class="field">
          <div class="channel-type">{{ configuredChannel?.channelTypeDisplay }}</div>
          <div><img [src]="configuredChannel?.logoImagePath" /></div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.NAME' | translate }}</label>
          <div>
            <input
              class="input is-fullwidth"
              type="text"
              placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.NAME' | translate }}"
              [(ngModel)]="configuredChannel.name"
              name="name" />
          </div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.DESCRIPTION' | translate }}</label>
          <div>
            <textarea
              name="description"
              class="textarea"
              placeholder="{{ 'MANAGEMENT.DATAFEEDS.DESCRIPTION' | translate }}"
            [(ngModel)]="configuredChannel.description"></textarea>
          </div>
        </div>
        <div class="field"
          fxLayout="row"
          fxLayoutAlign="space-between">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.SEND-DM' | translate }}</label>
          <div><topo-switch [checked]="sendDirectMessages" (click)="checkDirectMessage()"></topo-switch></div>
        </div>
        @if (configuredChannel?.settings?.isConnected) {
          <div
            class="field"
            >
            <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.SLACK-CHANNEL' | translate }}</label>
            <div>
              <div class="select is-secondary is-medium">
                <select [disabled]="sendDirectMessages"
                  name="selectedChannelId"
                  [(ngModel)]="selectedChannelId"
                  (ngModelChange)="selectSlackChannel()">
                  @for (slackChannel of slackChannels; track slackChannel.id) {
                    <option
                      [ngValue]="slackChannel.id">
                      {{ slackChannel.name }}
                    </option>
                  }
                </select>
              </div>
              <button
                class="mt-3 button is-danger is-medium"
                fxLayout="row"
                fxLayoutAlign="space-between center"
                style="font-weight: 600; font-size: 18px"
                (click)="disconnectFromSlack()">
                {{ 'MANAGEMENT.COMMUNICATION-CENTER.DISCONNECT' | translate }}
              </button>
            </div>
          </div>
        }
        @if (!configuredChannel?.settings?.isConnected) {
          <div
            class="field"
            >
            <button
              class="button is-secondary"
              fxLayout="row"
              fxLayoutAlign="space-between center"
              (click)="connectToSlack()">
              <i
                _ngcontent-vmg-c235=""
              class="icon icon-plug mr-4"></i>
              <span class="ml-3">{{ 'MANAGEMENT.COMMUNICATION-CENTER.CONNECT-WITH-SLACK' | translate }}</span>
            </button>
          </div>
        }
      </form>
    </div>
    <div class="modal-footer">
      <div
        fxLayout="row"
        fxLayoutAlign="end"
        class="mt-4 mb-4">
        <div style="margin-right: 5px">
          <button
            class="button is-secondary"
            (click)="cancelClick()">
            {{ 'MANAGEMENT.COMMUNICATION-CENTER.CANCEL' | translate }}
          </button>
        </div>
        <div>
          <button
            class="button is-primary"
            (click)="saveClick()">
            {{ 'MANAGEMENT.COMMUNICATION-CENTER.SAVE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </topo-modal>
}

<topo-spinner
  type="line-scale"
  [message]="'MANAGEMENT.COMMUNICATION-CENTER.LOADING-SLACK-CHANNELS' | translate"
bdColor="rgba(0,0,0,.4)"></topo-spinner>
